/**
 * Линзы выдачи «Движа» (BS §11.4): один и тот же подбор, разные срезы.
 * Базовые линзы фиксированы, линзы по интересам собираются из интересов
 * самого пользователя — «покажи тех, кто тоже за бег».
 */
import type { DiscoveryLens, Interest } from '@shared/api/types'
import type { IconName } from '@shared/ui'

export type LensId = DiscoveryLens

export interface LensOption {
  id: LensId
  label: string
  icon: IconName
}

export const DEFAULT_LENS: LensId = 'for_you'

export const BASE_LENSES: readonly LensOption[] = [
  { id: 'for_you', label: 'Для тебя', icon: 'sparkle' },
  // Изменение v1.5: линза «рядом» — это свой город, километров в продукте нет
  { id: 'nearby', label: 'Мой город', icon: 'pin' },
  { id: 'online', label: 'Онлайн', icon: 'activity' },
  { id: 'new', label: 'Новые', icon: 'star' },
]

/** Сколько собственных интересов становятся линзами. */
const INTEREST_LENSES_MAX = 6

export function interestLens(interestId: string): LensId {
  return `interest:${interestId}`
}

export function interestLenses(interests: readonly Interest[]): LensOption[] {
  return interests.slice(0, INTEREST_LENSES_MAX).map((interest) => ({
    id: interestLens(interest.id),
    label: interest.label,
    icon: 'hash',
  }))
}

export function lensOptions(interests: readonly Interest[]): LensOption[] {
  return [...BASE_LENSES, ...interestLenses(interests)]
}

/** Подпись линзы для пустого состояния и заголовков. */
export function lensLabel(id: LensId, interests: readonly Interest[]): string {
  return lensOptions(interests).find((lens) => lens.id === id)?.label ?? 'Для тебя'
}
